module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_GA-9f03abba3aae07be6e1db0d4351491de.svg";